import { ActiveFormActions } from "../states/activeForm";
import { AppState } from "../states/app-state.interface";
import { ProjectInterface as IProject } from "../models/interfaces/project.interface";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { Store } from "@ngrx/store";

@Injectable()
export class ActiveFormRepository {
  public currentForm$: Observable<any> = this.s.select(res => res.activeForm.form);
  public isDirty$ = this.s.select(res => res.activeForm.isDirty);

  constructor(
    private s: Store<AppState>,
    private activeFormActions: ActiveFormActions,
  ) { }

  public setForm(project: IProject) {
    this.s.dispatch(this.activeFormActions.setForm({ project }));
  }

  public setFormStepCompleted(step) {
    this.s.dispatch(this.activeFormActions.setFormStep({ step }));
  }

  public setActiveFormState(step, fields, valid) {
    this.s.dispatch(this.activeFormActions.setFormState({ step, fields, valid }));
  }

  public addOrUpdateMonster(monster) {
    this.s.dispatch(this.activeFormActions.addOrUpdateMonster({ monster }));
  }

  public setDirty(dirty) {
    this.s.dispatch(this.activeFormActions.setDirty({ dirty }));
  }

  deleteMonster(projectId: number, monsterId: number) {
    this.s.dispatch(this.activeFormActions.deleteMonster({ projectId, monsterId }));
  }
}



// WEBPACK FOOTER //
// ./src/repositories/activeForm.repository.ts